var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgShare2 = function SvgShare2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-16": 13,
    "data-width-24": 19,
    viewBox: "0 0 19 19.5",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M15.09 7.6a3.8 3.8 0 0 1-3.068-1.544.8.8 0 0 1-.172.164L7.546 8.921a3.8 3.8 0 0 1-.015 1.358l4.693 2.925q.088-.1.184-.195a3.8 3.8 0 1 1-.983 1.662L6.85 11.826a3.8 3.8 0 0 1-1.58 1.238 3.801 3.801 0 1 1 1.746-5.529L11.08 4.99a.75.75 0 0 1 .36-.102A3.799 3.799 0 1 1 15.09 7.6m0-6.09a2.3 2.3 0 1 0-.019 4.6 2.3 2.3 0 0 0 .019-4.6m0 11.91a2.3 2.3 0 1 0-.019 4.6 2.3 2.3 0 0 0 .019-4.6M2.524 7.656a2.3 2.3 0 1 1 2.552 3.827 2.3 2.3 0 0 1-2.552-3.827",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgShare2);
export default ForwardRef;